var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_2745)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.05108 12.9491C2.38251 12.3034 1.84923 11.5309 1.48237 10.6769C1.11551 9.82288 0.922404 8.90434 0.914327 7.97489C0.90625 7.04543 1.08336 6.12368 1.43533 5.2634C1.78729 4.40313 2.30707 3.62156 2.96431 2.96431C3.62156 2.30707 4.40313 1.78729 5.2634 1.43533C6.12368 1.08336 7.04543 0.90625 7.97489 0.914327C8.90434 0.922404 9.82288 1.11551 10.6769 1.48237C11.5309 1.84923 12.3034 2.38251 12.9491 3.05108C14.2242 4.3713 14.9297 6.13951 14.9138 7.97489C14.8978 9.81027 14.1617 11.566 12.8638 12.8638C11.566 14.1617 9.81027 14.8978 7.97489 14.9138C6.13951 14.9297 4.3713 14.2242 3.05108 12.9491ZM7.30008 4.50008V8.70008H8.70008V4.50008H7.30008ZM7.30008 10.1001V11.5001H8.70008V10.1001H7.30008Z",
    fill: "#F6AD01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_2745"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalid);
export default __webpack_public_path__ + "static/media/invalid.d08add1bcef3ec9850a2865e055bad70.svg";
export { ForwardRef as ReactComponent };